import { useEffect, useState, useLayoutEffect } from "react"; //Fragment,
import { Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import { getCustomPopUpURL } from "../../actions";
import { RootState } from "../../reducers";
import { ObjectUtils } from "../../utils";
import { ButtonComponent } from "../Button";

export const WindowDialogComponent = () => {
  const contentFooter = useSelector((state: RootState) => state?.common?.contentFooter?.contentResource?.contents);
  const helpContentResponse = useSelector((state: RootState) => state.common.helpContentResponse || null);
  const [showPopUpContent, setshowPopUpContent] = useState<boolean>(false);
  const [modalTitle, setmodalTitle] = useState<string>("");
  const [dialogClass, setdialogClass] = useState<string>("");

  // Address AODA concern FLEXS-11039: Include accessible name for dialog element
  // Related GitHub issue: https://github.com/reactstrap/reactstrap/issues/2822
  // Reference: https://github.com/react-bootstrap/react-bootstrap/issues/5084
  useLayoutEffect(() => {
    if (showPopUpContent) {
      // Target the outer div with role="dialog"
      const dialogElement = document.querySelector('[role="dialog"]');
      
      if (dialogElement) {
        // Add aria-label as fallback
        if (!dialogElement.hasAttribute('aria-label')) {
          dialogElement.setAttribute('aria-label', 'Dialog');
        }
        
        // Add aria-labelledby to point to the heading
        if (!dialogElement.hasAttribute('aria-labelledby')) {
          dialogElement.setAttribute('aria-labelledby', 'modalHeading modalSubtitle');
        }
      }
    }
  }, [showPopUpContent]);

  useEffect(() => {
    const handleURLClick = (event: any) => {
      const link = event?.target?.getAttribute("data-tid");
      const title = event?.target?.getAttribute("data-title") || "&nbsp;";
      const className = event?.target?.getAttribute("data-class");

      if (link) {
        getCustomPopUpURL(link, () => {
          setshowPopUpContent(true);
          setdialogClass(className);
          setmodalTitle(title);
        });
      }
    };
    const win: Window = window; // <-- DOM-Window, extends DOM-EventTarget
    win.addEventListener("click", handleURLClick);
    win.addEventListener("keypress", handleURLClick);
    return () => {
      window.removeEventListener("click", handleURLClick);
      window.removeEventListener("keypress", handleURLClick);
    };
  }, []);

  const handlePopUpClose = () => {
    setshowPopUpContent(false);
  };
  const closeButtonText = ObjectUtils.extractLabelFromObject(contentFooter || {}, "btnClose");
  return (
    <Modal isOpen={showPopUpContent} labelledBy="modalHeading modalSubtitle" className={dialogClass || ""} centered toggle={handlePopUpClose}>
      <div className={'modal-header'}>
        <h1 className={'modal-title'} >
          <span id="modalHeading" dangerouslySetInnerHTML={{ __html: modalTitle || '' }} />
          <span id="modalSubtitle" className="visuallyhidden" aria-hidden="true">dialog</span>
        </h1>
        {handlePopUpClose && (
          <ButtonComponent
            btndata={[
              {
                variant: "close",
                ariaLabel: closeButtonText.display,
                display: "×",
                onSubmit: handlePopUpClose
              }
            ]}
          />
        )}
      </div>
      <ModalBody>
        {showPopUpContent && (
          <div
            dangerouslySetInnerHTML={{
              __html: helpContentResponse?.result?.content
            }}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default WindowDialogComponent;
